module.exports = __webpack_public_path__ + "static/mr-concert-performance-22-3de3a21237d6e7f93ca25685e470e4e6.jpg";